import core from '~/core/scripts';
import '../styles/index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

// handle maps
const expandButton = document.querySelector('#expandbtn');
const expandSection = document.querySelector('.election-maps__parties.extended');
const lazyScreenshots = document.querySelectorAll('.lazy-screenshot');

const expand = () => {
  expandSection.style.display = 'flex';

  [].forEach.call(lazyScreenshots, (el) => {
     el.setAttribute('src', el.getAttribute('data-src'));
  });

  expandButton.style.display = 'none';
}

expandButton.addEventListener('click', expand);

if (process.env.NODE_ENV === 'development') {
  require('file-loader!../index.html');
}
